import {
  PickListProps,
} from '@NitrexGroup/primevue/picklist';

import {
  severityMap,
} from '../components/button/qmulus-button';

const ternaryButtonProps = {
  ...severityMap.tertiary,
};

export const PrimePickListButtonProps: PickListProps = {
  moveAllToSourceProps: ternaryButtonProps,
  moveAllToTargetProps: ternaryButtonProps,
  moveToSourceProps: ternaryButtonProps,
  moveToTargetProps: ternaryButtonProps,
  moveBottomButtonProps: ternaryButtonProps,
  moveDownButtonProps: ternaryButtonProps,
  moveTopButtonProps: ternaryButtonProps,
  moveUpButtonProps: ternaryButtonProps,
};
